import {Directive, HostListener} from '@angular/core';
import * as screenfull from 'screenfull';

@Directive({
    selector: '[toggleFullscreen]',
//    template:'<i class="fa fa-expand fa-fw text"></i><i class="fa fa-compress fa-fw text-active"></i>',
})
export class ToggleFullscreenDirective {
    @HostListener('click') onClick() {
        if (screenfull.enabled) {
            screenfull.toggle();
        }
    }
}


// WEBPACK FOOTER //
// /codebuild/output/src2455195120/src/src/app/directive/ui-fullscreen.ts